import React, { useEffect, useRef, useState } from 'react'
import { Flex, Box, Heading, Text } from 'rebass/styled-components';
import SpinLoader from '../../components/SpinLoader';
import { Input } from '../../components/TextInput';

interface OptInnerProps {
  mutate: any, loading: boolean, sendByEmail: any
}

export const OtpInner: React.FC<OptInnerProps> = ({ mutate, loading, sendByEmail }) => {
  const [value, setValue] = useState();
  const otpInput = useRef<any>(null);

  useEffect(() => {
    if(!!loading) return

    if (otpInput.current) {
      otpInput.current.focus();
    }
  }, [loading]);

  return (
    <Flex mb={4} flexDirection="column">
      <Box
        px={2}
        style={{
          width: '100%',
        }}
      >
        {!loading ? (
          <>
            <Heading textAlign="center" mb={3}>
              We sent you an SMS code
            </Heading>
          </>
        ) : (
          <Text>Verifying...</Text>
        )}
      </Box>
      {loading ? (
        <Flex
          px={2}
          flexDirection="column"
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '40px',
          }}
        >
          <SpinLoader />
        </Flex>
      ) : (
        <Flex px={2} flexDirection="column">
          <Text mb={2} textAlign="center" mt={3} style={{ fontWeight: 600 }}>
            Enter your code here
          </Text>
          <Flex justifyContent="center" alignItems="center" flexDirection="column">
            <Input
              style={{
                maxWidth: '250px',
                fontSize: '28px',
                letterSpacing: '16px',
                textAlign: 'center',
              }}
              placeholder="••••••"
              autoComplete="one-time-code"
              onChange={(r: any) => {
                setValue(r.target.value);
                if (r.target.value.length === 6) {
                  mutate(r.target.value);
                }
              }}
              autoFocus
              ref={otpInput}
              value={value}
            />
            <Text onClick={() => sendByEmail()} style={{ textDecoration: 'underline', cursor: 'pointer', textAlign: 'center' }} mt={4}>Send new code by email</Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};